// Global state for the auth modal
const globalState = reactive({
  loginModalRef: null
})

export const useAuthModal = () => {
  const setLoginModalRef = (ref) => {
    globalState.loginModalRef = ref
  }

  const openLoginModal = () => {
    if (globalState.loginModalRef?.openModal) {
      globalState.loginModalRef.openModal()
    } else {
      console.warn('Login modal ref is not available or openModal method not found')
    }
  }

  return {
    setLoginModalRef,
    openLoginModal
  }
}
